import React, { useState, useEffect } from "react";
import Logo from "../components/header/Logo";
import IconGroup from "../components/header/IconGroup";
import NavMenu from "../components/header/NavMenu";
import MobileMenu from "../components/header/MobileMenu";
import { useLocation } from "react-router-dom";
import useCategoriesCollections from "../helpers/useCategoriesCollections";
import { usePartner } from "../helpers/BrandPageAPI"
import LinkExpiredCounter from "../components/header/LinkExpiredCounter";

const HeaderTwo = () => {
  const [isSticky, setIsSticky] = useState(false);
  const { categoryData, collectionData } = useCategoriesCollections();
  const { partnerData } = usePartner();
  const storeLogo = partnerData?.StoreLogoUrl;
  const location = useLocation();
  const currentPath = location.pathname.replace(/\//g, "") || "";

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header className={`header-area clearfix header-hm9 transparent-bar ${currentPath}`}>
      <div className="container">
        <div className="header-top-area d-none d-lg-block">
          <div className="row header_top_con">
            <div className="col-lg-5 col-md-8 col-12">
              {/* linkexpiredcounter */}
              <LinkExpiredCounter />
            </div>
            <div className="col-lg-2 d-none d-lg-block text-center">
              {/* header logo */}
              <Logo imageUrl={storeLogo} logoClass="logo-hm-9" />
            </div>
            <div className="col-lg-5 col-md-4 col-12">
              {/* Icon group */}
              <IconGroup />
            </div>
          </div>
        </div>
      </div>
      <div className={`header-bottom sticky-bar header-res-padding header-padding-2 ${isSticky ? "stick" : ""}`}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-6 d-block d-lg-none">
              {/* header logo */}
              <Logo imageUrl={storeLogo} />
            </div>
            <div className="col-6 d-block d-lg-none">
              {/* Icon group */}
              <IconGroup />
            </div>
            <div className="col-xl-12 col-lg-12 d-none d-lg-block">
              {/* Nav menu */}
              <NavMenu
                categoryData={categoryData}
                collectionData={collectionData}
              />
            </div>
            <div className="col-12 d-flex d-lg-none align-items-center justify-content-center gap-2">
              {/* linkexpiredcounter */}
              <LinkExpiredCounter />
            </div>
          </div>
          {/* mobile menu */}
          <MobileMenu
            categoryData={categoryData}
            collectionData={collectionData}
          />
        </div>
      </div>
    </header>
  );
};

export default HeaderTwo;